import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { RootErrorBoundary } from './components/root-error-boundary';
import { Toaster } from './components/ui/toaster';
import { UpdateHandler } from './components/update-handler';
import { ApolloProvider } from './providers/apollo-provider';
import { AppCacheBootstrap } from './providers/app-cache-bootstrap';
import { AppConfigProvider } from './providers/app-config-provider';
import { ChakraProviderWithColorMode } from './providers/chakra-provider';
import { PageLayoutProvider } from './providers/page-layout-provider';
import { SidebarProvider } from './providers/sidebar-provider';
import { UserProvider } from './providers/user-provider';
import { getRegistration } from './utils/sw-registration';
import '@uiw/react-markdown-preview/markdown.css';
import './index.scss';

if (import.meta.env.PROD && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    void getRegistration();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppConfigProvider>
      <ApolloProvider>
        <RootErrorBoundary>
          <AppCacheBootstrap>
            <ChakraProviderWithColorMode>
              <UserProvider>
                <SidebarProvider>
                  <PageLayoutProvider>
                    <UpdateHandler />
                    <App />
                    <Toaster />
                  </PageLayoutProvider>
                </SidebarProvider>
              </UserProvider>
            </ChakraProviderWithColorMode>
          </AppCacheBootstrap>
        </RootErrorBoundary>
      </ApolloProvider>
    </AppConfigProvider>
  </React.StrictMode>,
);
